
import "./sass/main.scss";
import { BrowserRouter , Routes , Route } from "react-router-dom";
import HomeLayout from "./Pages/HomeLayout";
import About from "./Pages/About";
import Services from "./Pages/Services";
import Projects from "./Pages/Projects";
import Team from "./Pages/Team";
import Contact from "./Pages/Contact";
import Home from "./Pages/Home";
import { useEffect, useState } from "react";
import Error from "./Pages/Error";

function App() {

  return (
    <>
   <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeLayout/>}>
           <Route path="about" element={<About/>}/>
           <Route path="services" element={<Services/>}/>
           <Route path="projects" element={<Projects/>}/>
           <Route path="team" element={<Team/>}/>
           <Route path="contact" element={<Contact/>}/>
           <Route index element={<Home/>}/>
          </Route>
          <Route path="*" element={<Error/>}/>
        </Routes>
      </BrowserRouter> 
    </>
  );
}

export default App;
